var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.125 66C124.125 73.6331 122.622 81.1914 119.7 88.2435C116.779 95.2955 112.498 101.703 107.101 107.101C101.703 112.498 95.2955 116.779 88.2435 119.7C81.1914 122.622 73.6331 124.125 66 124.125C58.3669 124.125 50.8086 122.622 43.7565 119.7C36.7045 116.779 30.2968 112.498 24.8994 107.101C19.502 101.703 15.2206 95.2955 12.2995 88.2435C9.37845 81.1914 7.875 73.6331 7.875 66C7.875 58.3669 9.37845 50.8086 12.2995 43.7565C15.2206 36.7045 19.502 30.2968 24.8994 24.8994C30.2968 19.502 36.7045 15.2206 43.7565 12.2995C50.8086 9.37845 58.3669 7.875 66 7.875C73.6331 7.875 81.1914 9.37845 88.2435 12.2995C95.2955 15.2206 101.703 19.502 107.101 24.8994C112.498 30.2968 116.779 36.7045 119.701 43.7565C122.622 50.8086 124.125 58.3669 124.125 66L124.125 66Z",
    stroke: "#E0EBFF",
    strokeWidth: 14.5312
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.125 66C124.125 66.1217 124.125 66.2435 124.124 66.3652",
    stroke: "#9FB9E3",
    strokeWidth: 14.5312
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.54ccb6f697e4bbe65e61cfc4602b9fd8.svg";
export { ForwardRef as ReactComponent };